import _construct from "/mnt/c/onesaz/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import hsv2rgb from './hsv2rgb.js';
import rgb2hsv from './rgb2hsv.js';
Color.prototype.hsv = function () {
  return rgb2hsv(this._rgb);
};
var hsv = function hsv() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['hsv']));
};
chroma.hsv = hsv;
input.format.hsv = hsv2rgb;
input.autodetect.push({
  p: 2,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'hsv');
    if (type(args) === 'array' && args.length === 3) {
      return 'hsv';
    }
  }
});
export { hsv };